import type { PushWrapperFn } from "../../../types/scenarioAnalytics";
import { toGlobalId } from "../globalId";

type HandlePostalMailActionArgs = {
  id: string;
  shortCode: string | undefined;
  scenarioId: string | undefined;
  routerPush: PushWrapperFn;
  toPageKey?: string;
  fromIntentId?: string;
};

export const handlePostalMailAction = async ({
  id,
  shortCode,
  scenarioId,
  routerPush,
  toPageKey,
  fromIntentId,
}: HandlePostalMailActionArgs) => {
  try {
    const encodedId = toGlobalId("ScenarioVersionChildSolution", id);
    const url = shortCode ? `/c/${shortCode}/s/${encodedId}` : `/p/${scenarioId}/s/${encodedId}`;
    await routerPush(url, { toPageKey, fromIntentId });
    return true;
  } catch (_) {
    return false;
  }
};
